import ModifyNote from "./modify-note.vue";

export default ModifyNote;



// WEBPACK FOOTER //
// ./src/components/_modals/modify-note/index.js